import { createFileRoute } from '@tanstack/react-router'

import { LearnpathsAddElementsLink } from '@/learnpaths/components/LearnpathsAddElementsLink/LearnpathsAddElementsLink'

export const Route = createFileRoute(
  '/company/learnpaths/add/elements/$learnpathId/(link)/create/link',
)({
  component: RouteComponent,
  validateSearch: (search: { index?: number }) => search,
})

function RouteComponent() {
  return <LearnpathsAddElementsLink mode="create" />
}
